export const HOMEPAGE_BLOCKS = {
  HERO: "hero",
}
